import styled, { CSSProperties } from 'styled-components';

export const LegendWrapper = styled.div<{ direction: CSSProperties['flexDirection'] }>(({ direction = 'row' }) => ({
  display: 'flex',
  flexFlow: `${direction} nowrap`,
  alignItems: direction === 'column' ? 'flex-start' : 'flex-end',
  placeSelf: direction === 'column' ? 'flex-start' : 'flex-end',
  width: 'fit-content',
}));

export const LegendIcon = styled.div<{ color: string }>(({ color }) => ({
  border: `3px solid ${color}`,
  backgroundColor: color,
  borderRadius: '100%',
  height: '20px',
  aspectRatio: '1/1',
  marginRight: '8px',
  padding: 0,
}));

export const TextWrapper = styled.div<{ dir: CSSProperties['flexDirection'] }>(({ dir = 'row' }) => ({
  display: 'flex',
  flexFlow: `${dir} ${dir === 'column' ? 'nowrap' : 'wrap'}`,
  alignItems: 'center',
  justifyContent: 'space-between',
  textAlign: 'right',
  width: '100%',
}));

export const Row = styled.div({
  display: 'flex',
  flexFlow: 'row nowrap',
  alignItems: 'center',
  margin: '0 16px 16px 0',
  width: '100%',
});
